// extracted by mini-css-extract-plugin
export default {"hero":"fc716e643f63","about":"e7c2450e3a02"};